import { useState, useParams, FaPencilAlt, FaTrash, FaEye, ToastContainer, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle } from '../../common/common';

import useNavigation from '../../common/useNavigation';
import { useErrorContext } from '../../context/ErrorContext';
import MidBadges from '../../middleware/Settings/MidBadges';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import { Modal, Form } from "react-bootstrap";


const Badges = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, Remainuser, subUser, badges, isLoading, showEditModal, setShowEditModal, showDeleteModal, setShowDeleteModal, newTitle, setNewTitle, newColor, setNewColor, newTextColor, setNewTextColor, handleCloseEditModal, handleShowEditModal, handleCloseDeleteModal, handleShowDeleteModal, badgesDetails, setBadgesDetails, handleBadgeInput, handleChange, handleDelete, handleSaveChanges, showAddModal, setShowAddModal, handleCloseAddModal, handleShowAddModal, handlesubmit } = MidBadges(type);
    const { navigateGeneralSetting } = useNavigation();
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var ActiveUser = users[0]["Status"]
    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }
    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full ">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 text-xl text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Product Badges</h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fixed border-0 flex-row rounded-xl m-3 p-4 ">

                    <div className='flex flex-col lg:flex-row justify-between items-center mb-4'>
                        <h5 className=" capitalize text-xl font-bold mb-0">Badges</h5>

                        {ActiveUser === 1 &&
                            <button type="submit" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[200px]" onClick={handleShowAddModal}>
                                <span className="relative text-md text-black font-semibold pl-0" >Add New Badge</span>
                                <div className="lg:flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl hidden lg:block py-3 ">
                                    <FaEye className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                </div>
                            </button>
                        }


                    </div>
                    <div className="">
                        <div className="grid gap-2.5">
                            {badges.map((badge, index) => (
                                <div className="flex items-center justify-between flex-wrap group border border-gray-200 rounded-xl gap-2 px-3.5 ">
                                    <div className="flex items-center gap-2">
                                        <span className="text-gray-900 text-sm font-medium p-2 rounded-md" style={{ backgroundColor: badge.bgcolor, color: badge.textcolor }}>
                                            {badge.name}
                                        </span>
                                    </div>

                                    <div className="flex flex-row">

                                        {ActiveUser === 1 &&
                                            <Button variant="primary" onClick={(e) => handleShowEditModal(badge.id)} className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10">
                                                <FaPencilAlt className='text-[#193b99] m-auto' />
                                            </Button>
                                        }

                                        {ActiveUser === 1 &&
                                            <Button variant="primary" onClick={(e) => handleShowDeleteModal(badge.id)} className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10 text-center ">
                                                <FaTrash className='text-red-700 m-auto' />
                                            </Button>
                                        }
                                        
                                    </div>
                                </div>

                            ))}
                        </div>
                        {/* Add Modal */}
                        <Modal show={showAddModal} onHide={handleCloseAddModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Add New Badge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="title"
                                            value={badgesDetails.title}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Background Color</Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="bgcolor"
                                            value={badgesDetails.bgcolor}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Text Color</Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="textcolor"
                                            value={badgesDetails.textcolor}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseAddModal}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={handlesubmit}>
                                    Save
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Edit Modal */}
                        <Modal show={showEditModal} onHide={handleCloseEditModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Edit Badge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="title"
                                            value={badgesDetails.title}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Background Color</Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="bgcolor"
                                            value={badgesDetails.bgcolor}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Text Color</Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="textcolor"
                                            value={badgesDetails.textcolor}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseEditModal}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={handleSaveChanges}>
                                    Save Changes
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Delete Confirmation Modal */}
                        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Delete Badge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this badge?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleDelete}>
                                    Delete
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>

                </div>
            </div>
            <ToastContainer />
            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}
        </div>
    )
}

export default Badges